
    import {defineComponent, reactive, ComputedRef, computed, nextTick, onMounted, watch} from 'vue';
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import { Tab, Tabs } from 'scvant';
    import  reportMsgUt from "@/util/reportMsg";
    import DetectPlayer from '@/views/components/ALvideoPlayer/index.vue';
    import '@souche-ui/cyp_aliyunplayer/lib/styles/index.css';
    import {getVideoPlayAuth} from '@/service'

    interface State {
        checkItemsExplain: object[];
        activeName: string;
        reportMsg: object;
        loadedImages: number;
        allImagesLoaded: boolean;
        standardConfig: object;
        playAuth: string;
        standardVideoInfo: any;
        videoId: string;
        playData: any;
    }
    export default defineComponent({
        name: "checkStandard",
        components: {
            DetectPlayer,
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
        },
        setup() {
            let state: State = reactive({
                activeName: '事故检测',
                checkItemsExplain: [],
                reportMsg: {},
                loadedImages: 0,
                allImagesLoaded: false,
                playAuth: '',
                standardVideoInfo: {},
                videoId: '',
                playData: null,
                standardConfig: {
                    accident: {
                        title: '事故检测',
                        code: 'accident',
                        definitionList: [{
                            title: '事故车定义：',  
                            text: '经过碰撞、维修不当等外力作用，造成车辆结构件或加强件发生变化，即使修复后但仍存在安全隐患的车辆总称。',  
                        },{
                            title: '判定标准：',  
                            text: '不可拆水箱框架、导水槽、纵梁连接板等部位存在变形、钣金修复、烧焊等缺陷即认定为C级事故车。',  
                        },{
                            title: '',  
                            text: '底大边内侧、底大边外侧、不可拆水箱框架、翼子板内骨架、 后围板、导水槽、车顶、车顶边、后翼子板等部位存在切割；车身底板、行李箱底板、纵梁、减震器座、行李箱后遮物板（铁质）、防火墙、 A/B/C/D 柱内侧及封边、门槛梁存在切割、锈蚀锈透、烧焊等缺陷认定为D级事故车。（具体认定标准详见事故车认定标准表）',  
                        },{
                            title: '',
                            type: 'table',
                            tableType: 1,
                            tableData:{
                                title: '事故车认定标准',
                                subTitle: [
                                    '事故检测项',
                                    'C级事故车认定',
                                    'D级事故车认定',
                                ],
                                data:[{
                                    itemTitle: '不可拆卸水箱框架',
                                    list: ['（变形、钣金修复）≥9CM²；锈蚀锈透>5CM*5CM；烧焊', '切割'],
                                },{
                                    itemTitle: '左前纵梁',
                                    list: ['-', '（变形、钣金修复）≥3CM*3CM；锈蚀锈透>5CM*5CM；切割；胶体异常；烧焊'],
                                },{
                                    itemTitle: '右前纵梁',
                                    list: ['-', '（变形、钣金修复）≥3CM*3CM；锈蚀锈透>5CM*5CM；切割；胶体异常；烧焊'],
                                },{
                                    itemTitle: '左后纵梁',
                                    list: ['-', '（变形、钣金修复）≥3CM*3CM；锈蚀锈透>5CM*5CM；切割；胶体异常；烧焊'],
                                },{
                                    itemTitle: '右后纵梁',
                                    list: ['-', '（变形、钣金修复）≥3CM*3CM；锈蚀锈透>5CM*5CM；切割；胶体异常；烧焊'],
                                },{
                                    itemTitle: '左前纵梁连接板',
                                    list: ['（变形、钣金修复）≥3CM*3CM；锈蚀锈透>5CM*5CM；烧焊', '-'],
                                },{
                                    itemTitle: '右前纵梁连接板',
                                    list: ['（变形、钣金修复）≥3CM*3CM；锈蚀锈透>5CM*5CM；烧焊', '-'],
                                },{
                                    itemTitle: '左后纵梁连接板',
                                    list: ['（变形、钣金修复）≥3CM*3CM；锈蚀锈透>5CM*5CM；烧焊', '-'],
                                },{
                                    itemTitle: '右后纵梁连接板',
                                    list: ['（变形、钣金修复）≥3CM*3CM；锈蚀锈透>5CM*5CM；烧焊', '-'],
                                },{
                                    itemTitle: '左前门槛梁',
                                    list: ['-', '（变形、钣金修复）≥9CM²；锈蚀锈透>5CM*5CM；切割；封边不整；烧焊'],
                                },{
                                    itemTitle: '右前门槛梁',
                                    list: ['-', '（变形、钣金修复）≥9CM²；锈蚀锈透>5CM*5CM；切割；封边不整；烧焊'],
                                },{
                                    itemTitle: '左后门槛梁',
                                    list: ['-', '（变形、钣金修复）≥9CM²；锈蚀锈透>5CM*5CM；切割；封边不整；烧焊'],
                                },{
                                    itemTitle: '右后门槛梁',
                                    list: ['-', '（变形、钣金修复）≥9CM²；锈蚀锈透>5CM*5CM；切割；封边不整；烧焊'],
                                },{
                                    itemTitle: '左前减震器座',
                                    list: ['-', '（变形、钣金修复）≥3CM*3CM；锈蚀锈透>5CM*5CM；切割；胶体异常；烧焊'],
                                },{
                                    itemTitle: '右前减震器座',
                                    list: ['-', '（变形、钣金修复）≥3CM*3CM；锈蚀锈透>5CM*5CM；切割；胶体异常；烧焊'],
                                },{
                                    itemTitle: '左后减震器座',
                                    list: ['-', '（变形、钣金修复）≥3CM*3CM；锈蚀锈透>5CM*5CM；切割；胶体异常；烧焊'],
                                },{
                                    itemTitle: '右后减震器座',
                                    list: ['-', '（变形、钣金修复）≥3CM*3CM；锈蚀锈透>5CM*5CM；切割；胶体异常；烧焊'],
                                },{
                                    itemTitle: '左A柱内侧及封边',
                                    list: ['-', '变形≥9CM²；钣金修复≥9CM²且漆面厚度≥300um；锈蚀锈透>5CM*5CM；切割；封边不整；烧焊'],
                                },{
                                    itemTitle: '右A柱内侧及封边',
                                    list: ['-', '变形≥9CM²；钣金修复≥9CM²且漆面厚度≥300um；锈蚀锈透>5CM*5CM；切割；封边不整；烧焊'],
                                },{
                                    itemTitle: '左B柱内侧及封边',
                                    list: ['-', '变形≥9CM²；钣金修复≥9CM²且漆面厚度≥300um；锈蚀锈透>5CM*5CM；切割；封边不整；烧焊'],
                                },{
                                    itemTitle: '右B柱内侧及封边',
                                    list: ['-', '变形≥9CM²；钣金修复≥9CM²且漆面厚度≥300um；锈蚀锈透>5CM*5CM；切割；封边不整；烧焊'],
                                },{
                                    itemTitle: '左C柱内侧及封边',
                                    list: ['-', '变形≥9CM²；钣金修复≥9CM²且漆面厚度≥300um；锈蚀锈透>5CM*5CM；切割；封边不整；烧焊'],
                                },{
                                    itemTitle: '右C柱内侧及封边',
                                    list: ['-', '变形≥9CM²；钣金修复≥9CM²且漆面厚度≥300um；锈蚀锈透>5CM*5CM；切割；封边不整；烧焊'],
                                },{
                                    itemTitle: '左D柱内侧及封边',
                                    list: ['-', '变形≥9CM²；钣金修复≥9CM²且漆面厚度≥300um；锈蚀锈透>5CM*5CM；切割；封边不整；烧焊'],
                                },{
                                    itemTitle: '右D柱内侧及封边',
                                    list: ['-', '变形≥9CM²；钣金修复≥9CM²且漆面厚度≥300um；锈蚀锈透>5CM*5CM；切割；封边不整；烧焊'],
                                },{
                                    itemTitle: '左车顶边',
                                    list: ['烧焊', '切割'],
                                },{
                                    itemTitle: '右车顶边',
                                    list: ['烧焊', '切割'],
                                },{
                                    itemTitle: '车顶',
                                    list: ['烧焊', '切割'],
                                },{
                                    itemTitle: '左底大边内侧',
                                    list: ['锈蚀锈透>5CM*5CM；烧焊', '切割'],
                                },{
                                    itemTitle: '右底大边内侧',
                                    list: ['锈蚀锈透>5CM*5CM；烧焊', '切割'],
                                },{
                                    itemTitle: '左底大边外侧',
                                    list: ['-', '切割'],
                                },{
                                    itemTitle: '右底大边外侧',
                                    list: ['-', '切割'],
                                },{
                                    itemTitle: '左前翼子板内骨架',
                                    list: ['锈蚀锈透>5CM*5CM；烧焊', '切割'],
                                },{
                                    itemTitle: '右前翼子板内骨架',
                                    list: ['锈蚀锈透>5CM*5CM；烧焊', '切割'],
                                },{
                                    itemTitle: '左后翼子板内骨架',
                                    list: ['锈蚀锈透>5CM*5CM；烧焊', '切割'],
                                },{
                                    itemTitle: '右后翼子板内骨架',
                                    list: ['锈蚀锈透>5CM*5CM；烧焊', '切割'],
                                },{
                                    itemTitle: '左后导水槽',
                                    list: ['（变形、钣金修复）≥9CM²；锈蚀锈透>5CM*5CM；烧焊；胶体异常', '切割'],
                                },{
                                    itemTitle: '右后导水槽',
                                    list: ['（变形、钣金修复）≥9CM²；锈蚀锈透>5CM*5CM；烧焊；胶体异常', '切割'],
                                },{
                                    itemTitle: '左后翼子板',
                                    list: ['-', '切割'],
                                },{
                                    itemTitle: '右后翼子板',
                                    list: ['-', '切割'],
                                },{
                                    itemTitle: '车身底板',
                                    list: ['-', '（变形、钣金修复）≥225CM²；锈蚀锈透>5CM*5CM；切割；烧焊'],
                                },{
                                    itemTitle: '行李箱底板',
                                    list: ['-', '（变形、钣金修复）≥225CM²；锈蚀锈透>5CM*5CM；切割；胶体异常；烧焊'],
                                },{
                                    itemTitle: '行李箱后遮物板（铁质）',
                                    list: ['-', '钣金修复≥9CM²；切割；烧焊'],
                                },{
                                    itemTitle: '后围板',
                                    list: ['烧焊', '切割'],
                                },{
                                    itemTitle: '前围挡板（防火墙）',
                                    list: ['-', '(变形、钣金修复）≥9CM²；锈蚀锈透>5CM*5CM；切割；胶体异常；烧焊'],
                                },],
                            },
                        }],
                        
                    },
                    fire: {
                        title: '火烧检测',
                        code: 'fire',
                        definitionList: [{
                            title: '火烧车定义：',  
                            text: '车辆经燃烧、炙烤等高温作用，导致车辆部件受损或修复过后存在安全隐患的车辆。',  
                        },{
                            title: '判定标准：',  
                            text: '减震器座、发动机舱、车身线束、发动机舱内管路、行李箱等部位存在烟熏、碳化、受热变形、火烧修复、干粉残留缺陷任一情况，且单个部件缺陷面积大于等于0.3平方米，即认定为火烧车。',  
                        }]
                    },
                    water: {
                        title: '泡水检测',
                        code: 'water',
                        definitionList: [{
                            title: '泡水车定义：',  
                            text: '因涉水或浸泡导致车舱内进水，并影响车辆电子元件的正常工作，存在安全隐患的车辆。',  
                        },{
                            title: '判定标准：',  
                            text: '座椅滑轨、安全带、座椅坐垫底部、车顶篷、行李箱、保险丝盒、点烟器底座、转向柱、柱夹层及周边，驾驶室内控制单元等发现有明显的泡水迹象 (例如：含泥沙、水印、锈蚀、霉斑等情况) 若存在三种或大于三种情况，即认定为泡水车 (以下部件存在三项及以上且均为锈蚀的除外) 仅主驾地毯（胶）、副驾地毯（胶）、后排地毯（胶） 、座椅滑轨、行李箱底板存在相应缺陷，不判定为泡水车，并且主驾地毯（胶）、副驾地毯（胶）、后排地毯（胶）只算作一项，但是必须在报告在中注明。',  
                        }]
                    },
                    appearancePlus2503: {
                        title: '【加购】车身外观检测',
                        code: 'appearance',
                        definitionList: [{
                            title: '',  
                            text: '加购外观检测标准：根据加购检测项中出现钣金修复、变形、拆装痕迹、更换、剐蹭、腻子开裂、重做漆、破损、碎点等缺陷状况，综合判断为外观缺陷。',  
                        },{
                            title: '',  
                            text: '加购检测项赔付标准：加购检测项存在《加购服务协议》内对应的承保缺陷，而检测报告未予以准确反映的，经我们复检后确认检测失误的，268V向委托方进行一次性赔偿，具体赔偿详见《加购服务协议》。加购检测项中存在多个缺陷值未准确反映的，赔付金额不叠加。',  
                        }]
                    },
                    interiorPlus2503: {
                        title: '【加购】内饰检测',
                        code: 'interior',
                        definitionList: [{
                            title: '',  
                            text: '加购内饰检测标准：根据加购检测项中出现破损、缺失等缺陷状况，综合判断为内饰缺陷。',  
                        },{
                            title: '',  
                            text: '加购检测项赔付标准：加购检测项存在《加购服务协议》内对应的承保缺陷，而检测报告未予以准确反映的，经我们复检后确认检测失误的，268V向委托方进行一次性赔偿，具体赔偿详见《加购服务协议》。加购检测项中存在多个缺陷值未准确反映的，赔付金额不叠加。',  
                        }]
                    },
                    batteryDetect: {
                        title: '【加购】SOH（极速智检）',
                        code: 'batteryDetect',
                        definitionList: [{
                            title: '',
                            type: 'video',
                            text: '',
                        },{
                            title: 'SOH（State of Health）：',  
                            text: '指电池健康状态，以百分比表示。SOH=（动力电池当前最大容量÷动力电池额定容量）*100%。',  
                        },{
                            title: 'SOH（极速智检）',  
                            text: '由于没有对动力电池安全隐患进行检测，所以不对动力电池的SOH进行承保。',  
                        },{
                            title: '',
                            type: 'table',
                            tableType: 2,
                            tableClass: 'batterywarn',
                            tableData:{
                                title: '新能源车预报警与风险预警的参数与阈值',
                                subTitle: [
                                    '报警',
                                    '分级规则',
                                    '级别',
                                ],
                                data:[{
                                    itemTitle: '单体过压报警',
                                    list: [{
                                        itemTitle: '锰酸锂',
                                        list:[
                                            ['4.25V < u<sub>i</sub> < 4.35V', '预警'],
                                            ['4.35V ≤ u<sub>i</sub> ≤ 4.45V', '预警'],
                                            ['u<sub>i</sub> > 4.45V', '警告'],
                                        ]
                                    }, {
                                        itemTitle: '磷酸铁锂',
                                        list:[
                                            ['3.65V < u<sub>i</sub> < 3.75V', '预警'],
                                            ['3.75V ≤ u<sub>i</sub> ≤ 3.85V', '预警'],
                                            ['u<sub>i</sub> > 3.9V', '警告'],
                                        ]
                                    }, {
                                        itemTitle: '三元锂',
                                        list:[
                                            ['4.25V < u<sub>i</sub> < 4.4V', '预警'],
                                            ['4.4V ≤ u<sub>i</sub> ≤ 4.7V', '预警'],
                                            ['u<sub>i</sub> > 4.7V', '警告'],
                                        ]
                                    }, {
                                        itemTitle: '钛酸锂',
                                        list:[
                                            ['2.8V < u<sub>i</sub> < 3V', '预警'],
                                            ['3V ≤ u<sub>i</sub> ≤ 3.2V', '预警'],
                                            ['u<sub>i</sub> > 3.2V', '警告'],
                                        ]
                                    }],
                                },{
                                    itemTitle: '单体电压过低报警',
                                    list: [{
                                        itemTitle: '锰酸锂',
                                        list:[

                                            ['2.25V < u<sub>i</sub> < 2.5V', '预警'],
                                            ['2V ≤ u<sub>i</sub> ≤ 2.25V', '预警'],
                                            ['u<sub>i</sub> ≤ 2V', '警告'],
                                        ]
                                    }, {
                                        itemTitle: '磷酸铁锂',
                                        list:[
                                            ['1.8V < u<sub>i</sub> <2V', '预警'],
                                            ['1.6V ≤ u<sub>i</sub> ≤ 1.8V', '预警'],
                                            ['u<sub>i</sub> < 1.6V', '警告'],
                                        ]
                                    }, {
                                        itemTitle: '三元锂',
                                        list:[
                                            ['2.5V < u<sub>i</sub> <3V', '预警'],
                                            ['2V ≤ u<sub>i</sub> ≤2.5V', '预警'],
                                            ['u<sub>i</sub> < 2V', '警告'],
                                        ]
                                    }, {
                                        itemTitle: '钛酸锂',
                                        list:[
                                            ['1.3 < u<sub>i</sub> <  1.6V', '预警'],
                                            ['1 ≤ u<sub>i</sub> ≤ 1.3V', '预警'],
                                            ['u<sub>i</sub> < 1V', '警告'],
                                        ]
                                    }],
                                }, {
                                    itemTitle: '电池电压极差过大报警（电池单体电压最高值-最低值）',
                                    colspan: 2,
                                    list: [{
                                        itemTitle: '',
                                        list:[
                                            ['u<sub>max</sub> - u<sub>min</sub> > 0.2V', '警告'],
                                            ['0.1V < u<sub>max</sub> - u<sub>min</sub> ≤ 0.2V', '预警'],
                                            ['0.05V < u<sub>max</sub> - u<sub>min</sub> ≤ 0.1V', '预警'],
                                        ]
                                    }],
                                }, {
                                    itemTitle: '电池过温报警(电池最高温度值)',
                                    colspan: 2,
                                    list: [{
                                        itemTitle: '',
                                        list:[
                                            ['45°C < T<sub>i</sub> < 50°C(预警)', '预警'],
                                            ['50°C < T<sub>i</sub> < 60°C', '预警'],
                                            ['T<sub>i</sub> > 70°C', '警告'],
                                        ]
                                    }],
                                }, {
                                    itemTitle: '温度差异过大报警 (电池最高温度值-最低温度)',
                                    colspan: 2,
                                    list: [{
                                        itemTitle: '',
                                        list:[
                                            ['T<sub>max</sub> - T<sub>min</sub> > 5°C(预警)', '预警'],
                                            ['T<sub>max</sub> - T<sub>min</sub> > 8°C', '预警'],
                                            ['T<sub>max</sub> - T<sub>min</sub> > 8°C & T<sub>i</sub> > 45°C', '警告'],
                                        ]
                                    }],
                                }]
                            },
                        }],
                        
                    },
                    
                },
            })
            document.title= "检测标准解读";
            const {query} = useRoute();
            state.activeName = `${query.checkTitle}`;
            state.reportMsg = reportMsgUt;
            let store = useStore();
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            const {checkModuleList, standardVideoInfo} = reportData.value as any;
            let checkItems: any = [];
            let checkCount = checkModuleList.length;
            for (let i=0;i<checkCount;i++){
                let item = checkModuleList[i];
                if(item.code !== 'batterySafety' && item.code !== 'batteryAppearance') {
                    let version = item.checkStandardVersion || item.styleCode.split('_')[1];
                    if (version && state.standardConfig[version]) {
                        checkItems.push(state.standardConfig[version]);
                    } else {
                        continue;
                    }
                }
            }

            checkItems.push(state.standardConfig['batteryDetect'])
            const getPlayAuth = function (videoId) {
                videoId && getVideoPlayAuth({videoId}).then((res: any) => {
                    state.playAuth = res;
                    state.playData = {
                        playAuth: res,
                        vodId: state.videoId,
                        cover: state.standardVideoInfo && state.standardVideoInfo.videoFirstImg,
                        autoplay: false,
                        size: state.standardVideoInfo && state.standardVideoInfo.videoSize
                    }
                });
            };
            state.standardVideoInfo = standardVideoInfo ;
            state.videoId = state.standardVideoInfo && state.standardVideoInfo.videoId;
            getPlayAuth(state.videoId);
            // let psLocalTitle = '附录';
            // let psLocalContent = '事故车、水泡车、火烧车判定标准文件，国家标准GB/T30323-2013《二手车鉴定评估技术规范》，下载链接：https://cyd-prod.oss-cn-zhangjiakou.aliyuncs.com/1c0841d3e8eb92d39f61812ef091621c &#10; 中国汽车流通协会团体标准T/CADA 18-2021《乘用车鉴定评估技术规范》，下载链接：https://cyd-prod.oss-cn-zhangjiakou.aliyuncs.com/2660d2c2d8f13b27d232de0f86514680';
            // let ps: ComputedRef<string> = computed<string>(() => (store.state.reportData as any).ps);
            // let psTitle: ComputedRef<string> = computed<string>(() => (store.state.reportData as any).psTitle);
            // let appendix = {
            //     title: psTitle.value ? psTitle.value : psLocalTitle,
            //     code: 'Appendix',
            //     definitionList: [{
            //         title: '',
            //         text: ps.value ? ps.value : psLocalContent
            //     }]
            // }
            // checkItems.push(appendix);
            state.checkItemsExplain = checkItems;
            // console.log(JSON.stringify(state.checkItemsExplain));
            onMounted(() => {
                nextTick(() => {
                    let el: any = document.getElementById(state.activeName);
                    let top = el.offsetTop;
                    console.log('el: ', el, 'top: ', top);
                    window.scrollTo(0, top);
                });
            });
            return {
                state,
                getPlayAuth
            }
        },
        methods: {
            goBack(){
                history.go(-1)
            },
            imageLoaded() {
                this.state.loadedImages++;
                if (this.state.loadedImages === 4) {
                    this.state.allImagesLoaded = true;
                    let el: any = document.getElementById(this.state.activeName);
                    let top = el.offsetTop;
                    // console.log('top:', top);
                    window.scrollTo(0, top);
                }
            },
        }
    })
